import {useContext} from "react";
import LanguageContext from "../contexts/LanguageContext";
import en from "../content/en";
import de from "../content/de";

export default function usePortfolioContent() {
  const {lang} = useContext(LanguageContext);
  return lang === "de" ? de : en;
}
